<template>
  <div class="video_com">
    <video :src="videoSrc" preload="auto" :poster="videoPoster" :controls="controlBarShow" ref="video" @mousemove="videoMouse(true)" @mouseout="videoMouse(false)"></video>
    <div class="playBtn" @click="playVideo(currentIndex)" v-show="playBtnShow"></div>
    <div class="constrolBar"></div>
    <div class="expandIcon" :class="{right: videoListShow}" @click="toggleVideoListShow" v-show="expandIconShow" @mouseover="videoMouse(true)"></div>
    <transition name="el-zoom-in-right">
      <div class="video_list without_controlbar" @click="testClick" v-show="videoListShow">
        <ul>
          <li v-for="(item,index) in videosList" :key="index" @click="playVideo(index)" :class="{current: currentIndex === index}">{{item.Fdesc}}</li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { setTimeout, clearTimeout } from "timers";
export default {
  name: "VideoCom",
  props: {
    videosList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let videopost = "//udata.youban.com/webimg/xblhr/assets/images/pc-intoyouban/videopost.jpg";
    return {
      videoSrc: "",
      videoPoster: videopost,
      videoListShow: false,
      controlBarShow: false,
      playBtnShow: true,
      expandIconShow: true,
      currentIndex: 0,
      mouseTimeout: ""
    };
  },
  mounted() {
    this.$refs.video.addEventListener("pause", () => {
      this.playBtnShow = true;
      this.expandIconShow = true;
    });
    this.$refs.video.addEventListener("play", () => {
      this.playBtnShow = false;
    });
    this.$refs.video.addEventListener("ended", () => {
      this.currentIndex++;
      if (this.currentIndex >= this.videosList.length) {
        this.currentIndex = 0;
      }
      this.videoSrc = this.videosList[this.currentIndex].Furl;
      this.$refs.video.load();
      this.$refs.video.play();
    });
  },
  methods: {
    testClick() {},
    playVideo(currentIndex) {
      if (this.videosList[currentIndex]) {
        if (currentIndex == this.currentIndex) {
          if (this.videoSrc === "") {
            this.videoSrc = this.videosList[currentIndex].Furl;
            this.$refs.video.load();
            this.currentIndex = currentIndex;
            this.$refs.video.addEventListener("canplay", () => {
              this.$refs.video.play();
              // setTimeout(() => {
              //   if (!this.videoListShow) this.expandIconShow = false;
              // }, 3000);
            });
          } else {
            this.$refs.video.play();
          }
          // setTimeout(() => {
          //   if (!this.videoListShow) this.expandIconShow = false;
          // }, 3000);
          this.playBtnShow = false;
          this.controlBarShow = true;
        } else {
          this.videoSrc = this.videosList[currentIndex].Furl;
          this.$refs.video.load();
          this.currentIndex = currentIndex;
          this.$refs.video.addEventListener("canplay", () => {
            this.$refs.video.play();
            // setTimeout(() => {
            //   if (!this.videoListShow) this.expandIconShow = false;
            // }, 3000);
          });
          this.playBtnShow = false;
          this.controlBarShow = true;
        }
      } else {
        if (this.videosList.length > 0) {
          this.videoSrc = this.videosList[0].Furl;
          this.$refs.video.load();
          this.$refs.video.addEventListener("canplay", () => {
            this.$refs.video.play();
            // setTimeout(() => {
            //   this.expandIconShow = false;
            // }, 4000);
          });
          this.playBtnShow = false;
          this.controlBarShow = true;
        } else {
          Message({
            showClose: true,
            message: "暂时没有视频哦~~",
            type: "warning"
          });
        }
      }
    },
    toggleVideoListShow() {
      this.videoListShow = !this.videoListShow;
      // if (!this.videoListShow) {
      //   setTimeout(() => {
      //     this.expandIconShow = false;
      //   }, 4000);
      // }
    },
    videoMouse(bool) {
      if (!this.playBtnShow) {
        if (this.mouseTimeout) {
          clearTimeout(this.mouseTimeout);
        }
        this.expandIconShow = bool;
        if (!bool && this.videoListShow) {
          this.expandIconShow = true;
        }
        this.mouseTimeout = setTimeout(() => {
          if (!this.playBtnShow) this.expandIconShow = !bool;
          else this.expandIconShow = true;
        }, 3000);
      }
    }
  }
};
</script>
<style scoped>
.video-player-box {
  width: 100%;
  height: 100%;
  border-radius: 1rem;
}
.video_com {
  position: relative;
}
.video_list {
  position: absolute;
  top: 0;
  right: 0;
  width: 20%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.video_list.without_controlbar {
  height: 100%;
  border-radius: 0 10px 10px 0;
}
.video_list.controlbar {
  height: calc(100% - 30px);
  border-radius: 0 10px 0 0;
}
.expandIcon {
  width: 0;
  height: 0;
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  border-left: 12px solid transparent;
  border-right: 12px solid #67befd;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 50%;
  /* transform: translateY(-50%); */
  margin-top: -30px;
  z-index: 2;
  transition: all 0.2s ease-in-out;
}
.playBtn {
  width: 5em;
  height: 5em;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(43, 51, 63, 0.7);
}
.expandIcon:hover,
.playBtn:hover {
  opacity: 0.8;
  cursor: pointer;
}
.expandIcon.right {
  /* border-right: 12px solid transparent;
  border-left: 12px solid #67BEFD;
  right: -24px; */
  transform-origin: center center;
  transform: translateX(24px) rotate(180deg);
}
.playBtn:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border: 1em solid transparent;
  border-left-width: 1.8em;
  border-left-color: #fff;
  transform: translate(-0.7em, -50%);
}
.video_list li {
  color: #fff;
  font-size: 1em;
  line-height: 1.8em;
  padding: 0 0.4em;
  cursor: pointer;
}
.video_list li.current {
  color: #67befd;
}
</style>


